import { createTheme } from '@mui/material/styles';
import colors from './ui/colors';

const theme = createTheme({
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body1: 'span',
          body2: 'span',
        },
      },
    },
  },
  palette: {
    primary: {
      main: colors.chartreuse,
    },
    secondary: {
      main: colors.black,
    },
  },
  // TODO: use actual design values
  typography: {
    button: {
      textTransform: 'none',
      fontSize: '10px',
    },
    fontFamily: '\'Pangram\', \'Arial\', sans-serif', // Include fallbacks
    // h1: {
    //   fontFamily: "Pangram", // Override for specific typography variant
    //   fontWeight: 700,
    //   fontSize: "2.5rem",
    // },
    // body1: {
    //   fontFamily: "Pangram",
    //   fontWeight: 400,
    //   fontSize: "1rem",
    // },
  },
});

export default theme;
